<template>
  <button type="button" class="ws-fin-row" @click="$emit('click')">
    <div class="ws-fin-row__task">
      <span class="ws-fin-row__color" :style="{ backgroundColor: task.cor || '#6366f1' }" />
      <div class="ws-fin-row__task-body">
        <div class="ws-fin-row__title-row">
          <h3 class="ws-fin-row__title">{{ task.titulo }}</h3>
          <span v-if="task.colunaNome" class="ws-fin-row__coluna">{{ task.colunaNome }}</span>
        </div>
        <div v-if="tags.length" class="ws-fin-row__tags">
          <span
            v-for="tag in tags"
            :key="tag.id"
            class="ws-fin-row__tag"
            :style="{ backgroundColor: tag.cor || '#6366f1' }"
          >{{ tag.nome }}</span>
        </div>
        <div class="ws-fin-row__progress-wrap">
          <div class="ws-fin-row__progress-track">
            <div
              class="ws-fin-row__progress-fill"
              :style="{ width: `${progress}%`, backgroundColor: task.cor || '#6366f1' }"
            />
          </div>
          <span class="ws-fin-row__progress-pct">{{ progress }}%</span>
        </div>
      </div>
    </div>

    <div class="ws-fin-row__cell ws-fin-row__cell--open">
      <MoneyAmount :value="fin.valorPendente" size="sm" />
    </div>
    <div class="ws-fin-row__cell ws-fin-row__cell--paid">
      <MoneyAmount :value="fin.valorRecebido" size="sm" />
    </div>
    <div class="ws-fin-row__cell ws-fin-row__cell--overdue">
      <MoneyAmount :value="fin.valorVencido" size="sm" />
    </div>
    <div class="ws-fin-row__chevron" aria-hidden="true">
      <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
      </svg>
    </div>

    <div class="ws-fin-row__amounts-mobile">
      <div class="ws-fin-row__amt-m">
        <span class="ws-fin-row__amt-lbl">{{ t('workspaceFinanceiro.columns.open') }}</span>
        <MoneyAmount :value="fin.valorPendente" size="sm" />
      </div>
      <div class="ws-fin-row__amt-m">
        <span class="ws-fin-row__amt-lbl">{{ t('workspaceFinanceiro.columns.paid') }}</span>
        <MoneyAmount :value="fin.valorRecebido" size="sm" />
      </div>
      <div class="ws-fin-row__amt-m">
        <span class="ws-fin-row__amt-lbl">{{ t('workspaceFinanceiro.columns.overdue') }}</span>
        <MoneyAmount :value="fin.valorVencido" size="sm" />
      </div>
    </div>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/components/MoneyAmount.vue'

const { t } = useI18n()

const props = defineProps({
  task: { type: Object, required: true }
})

defineEmits(['click'])

const tags = computed(() => props.task?.tags || [])
const fin = computed(() => props.task?.financeiro || {})
const progress = computed(() => {
  const p = props.task?.progressoTarefaPercentual
  if (p == null) return 0
  return Math.min(100, Math.max(0, Number(p) || 0))
})
</script>
